import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8308b1b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["title"]
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src", "title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "flex-container-row align-center gap5",
    title: _ctx.tooltip
  }, [
    (_ctx.statusIcon)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: _ctx.statusIcon,
          class: "icon-bullet"
        }, null, 8, _hoisted_2))
      : _createCommentVNode("", true),
    _createElementVNode("span", null, _toDisplayString(_ctx.displayVersion), 1),
    (_ctx.showUpdateIcon)
      ? (_openBlock(), _createElementBlock("img", {
          key: 1,
          src: _ctx.iconLink,
          class: "icon-link",
          title: _ctx.localize('Update'),
          onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.goToUpdate && _ctx.goToUpdate(...args)), ["stop"]))
        }, null, 8, _hoisted_3))
      : _createCommentVNode("", true)
  ], 8, _hoisted_1))
}